import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/contact/query/', 'Matters');

tbl.add(new Xtc('profile', 'Profile').renderSlot('profile').noSort())
tbl.add(new Xtc('fullname', 'Name').renderSlot('fullname'))
// tbl.add(new Xtc('company', 'Company').renderSlot('company'))
// tbl.add(new Xtc('person.first_name', 'First name'))
// tbl.add(new Xtc('person.last_name', 'Last name').noSort())
// tbl.add(new Xtc('person.middle_name', 'Middle name').hidden())
tbl.add(new Xtc('emails[0].email_address', 'Emails').noSort())
tbl.add(new Xtc('phones[0].phone_number', 'Phone numbers').noSort())
tbl.add(new Xtc('websites[0].website_address', 'Websites').noSort())
tbl.add(new Xtc('addresses[0].city', 'City').noSort().hidden())
tbl.add(new Xtc('addresses[0].country_name', 'Country').hidden().noSort())
tbl.add(new Xtc('addresses[0].post_code', 'Post code').hidden().noSort())
tbl.add(new Xtc('addresses[0].street', 'Street').hidden().noSort())
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

